import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ChartPieIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "chart-pie",
  "ChartPieIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1151)"><path d="M7.33317 2.03658C4.3332 2.36821 1.99984 4.91159 1.99984 7.99996C1.99984 11.3137 4.68613 14 7.99984 14C11.0882 14 13.6316 11.6666 13.9632 8.66663H7.33317V2.03658ZM8.6665 2.03658V7.33329H13.9632C13.6558 4.55221 11.4476 2.34401 8.6665 2.03658ZM0.666504 7.99996C0.666504 3.94987 3.94975 0.666626 7.99984 0.666626C12.0499 0.666626 15.3332 3.94987 15.3332 7.99996C15.3332 12.05 12.0499 15.3333 7.99984 15.3333C3.94975 15.3333 0.666504 12.05 0.666504 7.99996Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1151"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default ChartPieIcon;
